<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="预测名称：">
              <global-select
                :setParams="{ scpForecastType: 'FC4' }"
                :focusGet="true"
                @change="handleNameChange"
                :value.sync="queryParams.forecastName"
                selectType="selectSearch"
                requestApi="/scp/fcNewProduct/forecastNamePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="forecastName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="预测期间">
              <global-select
                :setParams="{ scpForecastType: 'FC4' }"
                :focusGet="true"
                @change="handlerRangPicker"
                :value.sync="queryParams.forecastMonthTem"
                selectType="select"
                requestApi="/scp/fcNewProduct/monthList"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.versionCode"
                selectType="selectSearch"
                requestApi="/scp/fcNewProduct/versionCodePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="versionCode"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="版本说明">
                <a-input v-model="queryParams.versionDescription"/>
              </a-form-item>
            </a-col>
          </template> -->
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!--  <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>  -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary">新增</a-button>
      <a-button @click="$refs.createExport.show()" type="primary">导入</a-button>
      <a-button @click="handleTemplate">下载模版</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MISSING_FORECAST_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="forecastName" slot-scope="{ record, text }">
            <a @click="handleOperation(text,record)" class="ml10">{{ record.forecastName }}</a>
          </span>
          <template slot="month" slot-scope="{ record }">
            <span>{{ record.monthStart+"~"+record.monthEnd }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="versionCode" slot-scope="{ record }">
            <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a @click="handleDelete(record)">删除</a>
          </span>
        </ls-api-table>
        <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
        <create-export
          ref="createExport"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

    <script>
    import { apiFcNewProductList, scpDelSProduct } from '@/api/scp/new-product-forecast/new-product-forecast'

    import CreateForm from './components/CreateForm'
    import CreateExport from './components/CreateExport'

    import { generateLsTableResData } from '@/utils/util.js';
    export default {
      // eslint-disable-next-line
      name: 'Work-desk', // name要和rms配置菜单路由保存一致(首字母大写)
      components: {
        CreateForm,
        CreateExport
      },
      data () {
        return {
          monthTem: '',
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(apiFcNewProductList, true),
            pageCurrent: true
          },
          isEdit: false,
          currentId: "",
          // 控制搜索展开
          advanced: true,
          // 查询参数
          queryParams: {
            scpForecastType: 'FC4',
            monthTem: undefined,
            monthStart: '',
            monthEnd: '',
            versionCode: ''
          },
          mode: ['month', 'month'],
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 状态快码
          statusOptions: [
            {
              dictLabel: "有效",
              dictValue: "Y"
            },
            {
              dictLabel: "无效",
              dictValue: "N"
            }
          ],
          baseUomFlagOptions: [
            {
              dictLabel: "是",
              dictValue: "Y"
            },
            {
              dictLabel: "否",
              dictValue: "N"
            }
          ],
          // 表格字段
      // 表格字段
      columns: [
        {
          title: '预测名称',
          dataIndex: 'forecastName',
          align: 'center',
          width: 180
        },
        {
          title: '版本',
          width: 160,
          dataIndex: 'versionCode',
          scopedSlots: { customRender: 'versionCode' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '版本说明',
          dataIndex: 'versionDescription',
          width: 180,
          align: 'left'
        },
        {
          title: '预测起始月',
          dataIndex: 'forecastMonthStart',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '预测截止月',
          dataIndex: 'forecastMonthEnd',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          width: 100,
          align: 'center'
        },
        {
          title: '创建时间',
          width: 180,
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          width: 180,
          dataIndex: 'updateTime',
          align: 'center'
        },
        {
          title: '操作',
          stickyFixed: 'right',
          align: 'center',
          width: 80,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
          uomClassOptions: [],
          unitOfMeasureList: [],
          unitOfMeasureListNew: []
        }
      },
      created () {
        // this.getUnitOfMeasureList()
        // const lookupQueryParams = {
        //   lookupType: 'MDM_UOM_CLASSES',
        //   current: 1,
        //   pageSize: 100
        // }
        // this.getLookupListData(lookupQueryParams).then().then(response => {
        //   this.uomClassOptions = response.rows
        // })
      },
      mounted () {
       this.onSearch()
      },
      methods: {
        handleDelete (record) {
          const self = this
          this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            scpDelSProduct({ id: record.id }).then(response => {
          if (response.code === 200) {
            self.$message.success('删除成功')
            self.onSearch()
          } else {
            self.$message.error(response.msg)
          }
        })
          }
        })
      },
        /** 下载模板操作 */
      handleTemplate () {
      this.download('scp/fcNewProduct/template', {
      }, `预测缺失导入模板_${new Date().getTime()}.xlsx`)
    },
        handleOperation (text, record) {
        this.$router.push({ path: `/missing-forecast/detail/${record.forecastName}/${record.versionCode}/${record.versionDescription}` })
        },
        handleVersionChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
        this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
        },
        handleNameChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
        this.queryParams.startMonth = filteredItem[0].bringOutDataOne
        },
        handlerRangPicker (val, selectList) {
          if (val) {
            const [startStr, endStr] = val.split('-');
            this.queryParams.forecastMonthStart = startStr;
            this.queryParams.forecastMonthEnd = endStr;
          } else {
            this.queryParams.forecastMonthStart = undefined;
            this.queryParams.forecastMonthEnd = undefined;
          }
        },
        handleGoVersion (record) {
          this.$router.push({ path: `/missing-forecast/detail/${record.forecastName}/${record.versionCode}/${record.versionDescription}` })
        },
          handlePanelChange (value, mode) {
            const yearMonth1 = value[0].format('YYYYMM')
            const yearMonth2 = value[1].format('YYYYMM')
            this.queryParams.monthStart = yearMonth1
            this.queryParams.monthEnd = yearMonth2
            this.monthTem = value
          },
        blur (record) {
          if (!record.conversionRate || Number(record.conversionRate) <= 0) {
            this.$message.warning('折换不能为空且需大于0')
          } else {
            record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
          }
        },
        statusOnChange (record) {
          record.status = record.status === 'Y' ? 'N' : 'Y'
        },
        // 导入导出excel
        /** 导出按钮操作 */
        handleExport () {
          this.download('mdm/mdmUomConversions/export', {
            ...this.queryParams
          }, `标准单位转换_${new Date().getTime()}.xlsx`)
        },
        // 编辑
        handleEdit (record) {
          if (this.currentId && record.id !== this.currentId && this.isEdit) {
            this.$message.warning('请保存上次编辑的数据')
            return;
          }
          this.isEdit = true;
          this.currentId = record.id;
        },
        // 编辑-保存
        // handleSave (record) {
        //   if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        //     this.$message.warning('折换不能为空且需大于0')
        //     return
        //   }
        //   updateUnit(record).then(response => {
        //     if (response.code === 200) {
        //       this.$message.success('保存成功')
        //       this.onSearch()
        //       this.isEdit = false;
        //     } else {
        //       this.$message.error(response.msg)
        //     }
        //   })
        // },
        // 取消
        handleCancel (record) {
          this.isEdit = false
          this.onSearch()
        },
        // 新增/修改框事件
        handleOk () {
           this.onSearch()
        },
        // 表单搜索
        onSearch () {
          this.isEdit = false
          this.$refs.dataTable.searchParams = this.queryParams;
          this.$refs.dataTable.getData();
        },
        /** 重置按钮操作 */
        resetQuery () {
          this.queryParams = {
            scpForecastType: 'FC4',
            monthTem: undefined,
            monthStart: '',
            monthEnd: '',
            versionCode: ''
          }
          this.onSearch()
        },
        // 搜索框展开、收起
        toggleAdvanced () {
          this.advanced = !this.advanced
        }
      }
    }
    </script>

    <style scoped lang="less">
    .ml10{
      margin-left: 10px;
    }
    </style>
